/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { NgModule } from '@angular/core';

import { DiskTypePipe } from './disk-type.pipe';
import { KeyAlgorithmPipe } from './key-algorithm.pipe';
import { KeyValuePipe } from './key-value.pipe';
import { UnitTransformPipe } from './unit-transform.pipe';

@NgModule({
    exports: [KeyValuePipe, DiskTypePipe, KeyAlgorithmPipe, UnitTransformPipe],
    declarations: [KeyValuePipe, DiskTypePipe, KeyAlgorithmPipe, UnitTransformPipe],
    providers: [KeyValuePipe, DiskTypePipe, KeyAlgorithmPipe, UnitTransformPipe],
})
export class PipesModule { }
